import DropdownMenu from "parent/src/js/base/Controllers/DropdownMenu";

export default class SiteHeader {

	isSearchActive = false;

	constructor(mainInstance, isLayoutAdjustmentsEnabled = true) {
		this.main = mainInstance;
		this.$el = document.getElementById("SiteHeader");
		this.currentScrollTop = window.scrollY;
		this.isLayoutAdjustmentsEnabled = isLayoutAdjustmentsEnabled;
		this.logoOriginalSize = {
			width: -1,
			height: -1
		};

		if (this.$el) {
			// Branding
			/**
			 * @type {HTMLElement}
			 */
			this.branding = this.$el.querySelector(".branding");
			// Navigation & Menus
			/**
			 * @type {HTMLElement}
			 */
			this.mainNavigation = this.$el.querySelector("nav.header-main-navigation");
			/**
			 * @type {HTMLElement}
			 */
			this.sideNavigation = this.$el.querySelector("nav.header-side-navigation");
			/**
			 * @type {HTMLElement}
			 */
			this.sideNavHamburger = this.mainNavigation.querySelector(".side-navigation-toggle .hamburger");
			/**
			 * @type {HTMLElement}
			 */
			this.mobileNavigation = this.$el.querySelector("nav.mobile-navigation");
			/**
			 * @type {HTMLElement}
			 */
			this.primaryMenu = this.$el.querySelector("ul.primary-menu");
			/**
			 * @type {HTMLElement}
			 */
			this.secondaryMenu = this.$el.querySelector("ul.secondary-menu");

			this.dropdown = new DropdownMenu(this.mainNavigation, this.$el);

			/**
			 * @type {HTMLElement}
			 */
			this.searchFormEl = this.$el.querySelector(".search-form");

			if (this.searchFormEl) {
				/**
				 * @type {HTMLElement}
				 */
				this.searchToggleEl = this.$el.querySelector(".search-toggle");
				/**
				 * @type {HTMLElement}
				 */
				this.searchWrapper = this.$el.querySelector(".search-form-wrapper");

				/**
				 *
				 * @type {HTMLInputElement}
				 */
				this.searchInputEl = this.searchFormEl.querySelector("input");

				if (this.searchToggleEl) {
					this.searchToggleEl.addEventListener("click", this.onSearchToggleClick.bind(this));
				}

			}

			window.addEventListener("scroll", this.onUpdate.bind(this), {
				passive: true
			});
			window.addEventListener("resize", this.main.debounce(this.onUpdate.bind(this)));
			window.addEventListener('load', this.initSideNavigationToggle.bind(this));

			if (this.currentScrollTop > 0) {
				this.updateClassName();
			}

			this.addLayoutObserver();
		}
	}

	addLayoutObserver() {
		if (this.isLayoutAdjustmentsEnabled) {
			if (typeof window.ResizeObserver === "function") {
				const observer = new window.ResizeObserver(this.adjustComponentSizes.bind(this));
				observer.observe(this.$el, {
					box: "border-box"
				});

			}
			else {
				window.addEventListener("resize", this.adjustComponentSizes.bind(this));
			}

			this.adjustComponentSizes();
		}
	}



	/**
	 * @returns {HTMLElement}
	 */
	getElement() {
		return this.$el;
	}

	getHeight() {
		return this.$el.clientHeight;
	}



	/**
	 * @param {Event} e
	 */
	onUpdate(e) {
		this.currentScrollTop = window.scrollY;
		this.updateClassName();
	}

	adjustComponentSizes() {
		let percent = 0;
		if (this.logoOriginalSize.width === -1) {
			this.logoOriginalSize.width = parseInt(this.branding.style.maxWidth);
			this.logoOriginalSize.height = parseInt(this.branding.style.maxHeight);
		}

		this.branding.style.flexBasis = null;
		this.branding.style.maxWidth = null;
		this.mainNavigation.style.flexBasis = null;
		this.mainNavigation.style.maxWidth = null;
		this.mobileNavigation.style.flexBasis = null;
		this.mobileNavigation.style.maxWidth = null;
		let wHeader = this.$el.clientWidth;
		let wBranding = this.branding.clientWidth;
		let wMainNavigation = this.mainNavigation.clientWidth;
		let wMobileNavigation = this.mobileNavigation.clientWidth;
		let styleMobileNavigation = window.getComputedStyle(this.mobileNavigation);
		if (styleMobileNavigation.display !== "none") {
			percent = Math.floor(wMobileNavigation / wHeader * 100)
			this.mobileNavigation.style.flexBasis = percent + "%";
			this.mobileNavigation.style.maxWidth = percent + "%";
			this.branding.style.flexBasis = 100 - percent + "%";
			this.branding.style.maxWidth = 100 - percent + "%";
		}
		else {
			if (wBranding + wMainNavigation > wHeader) {
				let wPrimaryMenu = this.mainNavigation.querySelector(".primary-menu").clientWidth + 40;
				percent = Math.floor(wPrimaryMenu / wHeader * 100);
				this.branding.style.flexBasis = 100 - percent + "%";
				this.branding.style.maxWidth = 100 - percent + "%";
				this.mainNavigation.style.flexBasis = percent + "%";
				this.mainNavigation.style.maxWidth = percent + "%";
			}
			else {
				this.branding.style.flexBasis = this.logoOriginalSize.width + "px";
				this.branding.style.maxWidth = this.logoOriginalSize.width + "px";
				this.branding.style.maxHeight = this.logoOriginalSize.height + "px";
				this.mainNavigation.style.flexBasis = null;
				this.mainNavigation.style.maxWidth = null;
			}
		}
	}

	initSideNavigationToggle() {
		if (this.sideNavigation && this.sideNavHamburger) {
			this.sideNavHamburger.addEventListener("click", (e) => {
				e.preventDefault();
				if (this.sideNavHamburger.classList.contains("active")) {
					this.sideNavigation.classList.remove("active");
					this.sideNavHamburger.classList.remove("active");
				}
				else {
					this.sideNavigation.classList.add("active");
					this.sideNavHamburger.classList.add("active");
				}
			});
		}
	}

	updateClassName() {
		if (this.lastScrollTop !== this.currentScrollTop) {
			if (this.currentScrollTop > 0) {
				window.document.body.classList.add("scrolled");

			}
			else {
				window.document.body.classList.remove("scrolled");
			}

			this.lastScrollTop = this.currentScrollTop;
		}
	}

	/**
	 *
	 * @param {Event} e
	 */
	onSearchToggleClick(e) {
		this.isSearchActive = !this.isSearchActive;

		this.$el.classList.toggle("search-active");
		this.searchWrapper.classList.toggle("active");
	}

	/**
	 *
	 * @param {Event} e
	 */
	onSearchCancelClick(e) {
		this.$el.classList.remove("search-active");
		this.isSearchActive = false;
	}
}
